import { createShopifyAnalyticsProcessor } from "./shopify-analytics";
import { AnalyticsEvent, type StorefrontAnalyticsLike } from "./types";
import { getTrackingValues } from "./utils/tracking-values";

const DESTINATION_NAME = "shopify-analytics";

export function bootstrapShopifyAnalytics(bus: StorefrontAnalyticsLike) {
  const analytics = createShopifyAnalyticsProcessor();

  bus.addDestination({
    name: DESTINATION_NAME,
    setup({ subscribe }) {
      for (const eventName of Object.values(AnalyticsEvent)) {
        subscribe(eventName, (payload, context) => {
          analytics.handleEvent(eventName, payload, {
            getTrackingValues: context?.getTrackingValues ?? getTrackingValues,
          });
        });
      }
    },
  });
}
